var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-box"},[_c('div',{staticClass:"location"},[_vm._v("추천 플레이리스트 관리 > 추천 플레이리스트 추가")])])
}]

export { render, staticRenderFns }